export default "__VITE_ASSET__QzPAE8ZC__"